export const pricesColumnHeader = {
  NAME: 'name',
  ONLINE: 'online',
  OFFLINE: 'offline',
}

export const version = 'v2.0.3'